import api from './api';

/**
 * Get all todos
 * @returns {Promise<Array>} Array of todos
 */
export const getTodos = async () => {
  try {
    const response = await api.get('/todos');
    return response.data;
  } catch (error) {
    console.error('Error fetching todos:', error);
    throw error;
  }
};

/**
 * Create a new todo
 * @param {Object} todoData - Todo data
 * @param {string} todoData.title - Todo title (required)
 * @param {string} todoData.description - Todo description (optional)
 * @param {string} todoData.priority - Priority: 'low', 'medium', 'high' (default: 'medium')
 * @returns {Promise<Object>} Created todo
 */
export const createTodo = async (todoData) => {
  try {
    const response = await api.post('/todos', todoData);
    return response.data;
  } catch (error) {
    console.error('Error creating todo:', error);
    throw error;
  }
};

/**
 * Update a todo
 * @param {number} id - Todo ID
 * @param {Object} todoData - Updated todo data
 * @param {string} todoData.title - Todo title
 * @param {string} todoData.description - Todo description
 * @param {string} todoData.priority - Priority: 'low', 'medium', 'high'
 * @param {boolean} todoData.completed - Completion status
 * @returns {Promise<Object>} Updated todo
 */
export const updateTodo = async (id, todoData) => {
  try {
    const response = await api.put(`/todos/${id}`, todoData);
    return response.data;
  } catch (error) {
    console.error(`Error updating todo ${id}:`, error);
    throw error;
  }
};

/**
 * Toggle todo completed status
 * @param {number} id - Todo ID
 * @returns {Promise<Object>} Updated todo
 */
export const toggleTodo = async (id) => {
  try {
    const response = await api.patch(`/todos/${id}/toggle`);
    return response.data;
  } catch (error) {
    console.error(`Error toggling todo ${id}:`, error);
    throw error;
  }
};

/**
 * Delete a todo
 * @param {number} id - Todo ID
 * @returns {Promise<Object>} Response object
 */
export const deleteTodo = async (id) => {
  try {
    const response = await api.delete(`/todos/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting todo ${id}:`, error);
    throw error;
  }
};

/**
 * Reorder todos
 * @param {Array<Object>} todos - Array of todos with id and order_index
 * @returns {Promise<Array>} Updated todos array
 */
export const reorderTodos = async (todos) => {
  try {
    const response = await api.put('/todos/reorder', { todos });
    return response.data;
  } catch (error) {
    console.error('Error reordering todos:', error);
    throw error;
  }
};

export default {
  getTodos,
  createTodo,
  updateTodo,
  toggleTodo,
  deleteTodo,
  reorderTodos
};
